<template>
  <ValidationObserver ref="observer">
    <div>
      <component-header
        title="Create Customer"
        :isLoading="loading"
        :hasReload="false"
        :hasSearch="false"
        :hasback="false"
        :hasCreate="false"
      />
      <b-card>
        <b-row class="mt-3">
          <b-col md="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="First Name"
            >
              <c-input
                inputType="text"
                lableText="First Name"
                v-model="firstName"
              />
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Last Name"
            >
              <c-input
                inputType="text"
                lableText="Last Name"
                v-model="lastName"
              />
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Email"
            >
              <c-input inputType="text" lableText="Email" v-model="email" />
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md="6">
            <c-tel-input v-model="phone" />
          </b-col>
          <b-col md="6">
            <eb-select
              type="select"
              label="label"
              placeholder="Select Unit Type"
              v-model="unitType"
              @input="onSelectUnitType"
              :options="unitOption"
            ></eb-select>
          </b-col>
          <b-col md="6">
            <!-- <c-input inputType="text" lableText="Unit" v-model="unit" /> -->
            <eb-select
              type="select"
              label="unitNo"
              placeholder="Select Unit"
              v-model="unit"
              :options="units"
            ></eb-select>
          </b-col>
          <b-col md="6">
            <c-input inputType="text" lableText="Floor" v-model="floor" />
          </b-col>
          <b-col md="6">
            <c-input inputType="text" lableText="Block" v-model="block" />
          </b-col>
          <b-col md="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Lease Start"
            >
              <c-input
                inputType="date"
                lableText="Lease Start"
                v-model="leaseStart"
              />
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Lease End"
            >
              <c-input
                inputType="date"
                lableText="Lease End"
                v-model="leaseEnd"
              />
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <DynamicInput
              :fields="externalInfoCustomer"
              :visibility="isVisible"
              ref="dynamicForm"
              @update:formData="handleExtendedAttributesUpdate"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-button variant="success" class="mr-2" @click="$router.go(-1)"
            >CANCEL</b-button
          >
          <div v-if="isLoading" class="spinner-overlay">
            <div class="spinner"></div>
          </div>
          <b-button variant="success" @click="createCustomer">SUBMIT</b-button>
        </b-row>
      </b-card>
    </div>
  </ValidationObserver>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import DynamicInput from "@/components/Partner/additionalInfo.vue";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";
import { mapState } from "vuex";
export default {
  components: {
    ComponentHeader,
    cInput,
    cTelInput,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
    Validator,
    DynamicInput,
  },
  data() {
    return {
      externalInfoCustomer: [],
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      unit: "",
      unitType: "",
      floor: "",
      block: "",
      leaseStart: null,
      leaseEnd: null,
      isLoading: false,
      unitOption: [
        { label: "1 Bed 1 Bath", value: { bed: 1, bath: 1 } },
        { label: "2 Bed 2 Bath", value: { bed: 2, bath: 2 } },
        { label: "3 Bed 2.5 Bath", value: { bed: 3, bath: 2.5 } },
        { label: "studio", value: { bed: 0, bath: 1 } },
      ],
      loading: false,
      units: [],
    };
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
    }),
    isVisible() {
      return this.externalInfoCustomer.length >= 0;
    },
  },
  methods: {
    handleExtendedAttributesUpdate(updatedData) {
      this.extendedAttributes = updatedData;
    },
    async getAttributeList() {
      this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
        this.externalInfoCustomer = this.extendedList.externalInfoCustomer;
      });
    },
    async onSelectUnitType(e) {
      const payload = {
        id: "66fa140f6a471d55dac5177b",
        bath: e.value.bath,
        bed: e.value.bed,
        page: 1,
      };
      await this.$store
        .dispatch("unit/fetchUnitDetails", payload)
        .then((res) => {
          this.units = res;
        });
    },
    async createCustomer() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      const payload = {
        type: "orderActive",
        customerDetails: {
          orderAmount: 70,
          customerName: this.firstName + this.lastName,
          name: {
            first: this.firstName,
            last: this.lastName,
          },
          customerPhone: this.phone.replace(/\s+/g, "").slice(-10),
          customerEmail: this.email,
        },
        extendedAttributes: this.extendedAttributes,
        providerDetails: {
          category: "DISTRIBUTOR",
          id: "65641df8c5ad7b08884e7cd4",
          name: this.firstName + this.lastName,
          email: this.email,
          phone: this.phone,
        },
        orderDetails: {
          unit: {
            ...this.unit,
            leaseStart: this.leaseStart,
            leaseEnd: this.leaseEnd,
          },
          unitType: this.unitType,
          floor: this.floor,
          block: this.block,
          leaseStart: this.leaseStart,
          leaseEnd: this.leaseEnd,
          deliveryAddress: {
            address: {
              location: {
                coordinates: [22.6636967, 87.74680710000001],
                type: "point",
              },
              isdefault: false,
              contacts: [
                {
                  _id: "66b9a628ef862f700238fd68",
                  value: this.phone,
                  contacttype: "primary_phone",
                },
                {
                  _id: "66b9a628ef862f60ca38fd67",
                  value: this.email,
                  contactType: "PRIMARY_EMAIL",
                },
              ],
              _id: "66b9a628ef862fc3fb38fd66",
              fullName: this.firstName + this.lastName,
              houseNumber: "DF38",
              street2: "Company",
              street1: "Area",
              zip: "721212",
              city: "Ghatal",
              state: "West Bengal",
              country: "India",
              category: "Home",
            },
            loc: {
              coordinates: [22.6636967, 87.74680710000001],
              type: "Point",
            },
          },
          items: [
            {
              productId: "66de7fb97f0a511360996cff",
              tenant: "66f1000a05fe0c77e56a7624",
              provider: "66b609e7ef862f7f4c38fbf9",
              providerName: "Allseller",
              name: "Sooji",
              description: "Sooji",
              imageLink:
                "https://nipigedev-storage.s3.amazonaws.com/images/seller/items/m0uj0vwv0d5jp",
              inventoryItems: [],
              qty: 1,
              unitPrice: 80,
              unitAmount: 80,
              price: 70,
              finalPrice: 70,
              priceBeforeTax: 0,
              discount: 10,
              discountAmount: 10,
              isSelfPickUp: true,
              offerCode: "",
              shipFrom: "IN",
              shipTo: "IN",
              country: "IN",
              taxes: [],
              totalTaxes: 0,
              status: "LOCKED",
              pickUpTime: "2024-09-26T09:30:00.000Z",
              delivery: {
                courier_company_id: 1,
                courier_name: "self",
                charge: 0,
                customer_bill: 0,
                etd: "",
              },
            },
          ],
        },
        txData: {
          orderId: "3",
          referenceId: "",
          txStatus: "",
          txMsg: "",
          txTime: "",
          signature: "",
          PaymentServiceName: "",
        },
        createdAt: "2024-09-26T11:43:28.406Z",
        payment: {
          type: "COD",
          orderId: "3",
        },
        isNew: true,
      };
      try {
        this.$store
          .dispatch("onboardCustomer/onboardNewCustomer", payload)
          .then((res) => {
            this.isLoading = false;
            this.$swal({
              title: "Success",
              text: "Customer Edit successfully!",
              type: "success",
            });
            this.$router.go(-1);
          });
      } catch {
        this.isLoading = false;
        console.error(error);
        this.$toasted.error("Customer Creation Failed: " + error.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    unit(newValue) {
      const selectedUnit = this.units.find((u) => u.unitNo === newValue.unitNo);
      if (selectedUnit) {
        this.floor = selectedUnit.Floor;
        this.block = selectedUnit.Block;
      }
    },
  },
  mounted() {
    this.getAttributeList();
  },
};
</script>
<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.spinner {
  border: 6px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
